import React, { useEffect } from 'react';
import { toast } from 'react-toastify';
import { messaging } from '../Hooks/FirebaseConfig';
import { getToken, onMessage } from 'firebase/messaging';
import { getFirestore, doc, setDoc } from 'firebase/firestore';
import { FCMTokenInsert } from '../apis/api/ChatApi';
import { useDispatch,useSelector } from 'react-redux';
import { MessageCircle } from "lucide-react";
import Cookies from "js-cookie"

const NotificationHandler = ({ userId }) => {
  const db = getFirestore();
const dispatch = useDispatch()
const CompanyId = Cookies.get("company_id")
  const requestPermission = async () => {
    try {
      const permission = await Notification.requestPermission();
      console.log("Notification permission:", permission);

      if (permission === 'granted') {
        const token = await getToken(messaging, {
          vapidKey: 'BCho0WIeWpjEOID9aHVaC-M_ky41c-ihJFFCBHkk1dUh8J-8XXr55GL_Djg6H32qXB27N8lnh6yzidgQkxBdlcA', // Replace with your Firebase Console key
        });
       

        if (token) {
        const response = await dispatch(FCMTokenInsert({"FCMToken":token,"CompanyId":CompanyId,"userId":userId}))
          console.log('FCM Token:', token);

          await setDoc(
            doc(db, 'users', userId),
            { fcmToken: token },
            { merge: true }
          );
        }
      }
    } catch (error) {
      console.error('Error getting permission or token:', error);
    }
  };

  useEffect(() => {
    if (userId) {
      requestPermission();

      const unsubscribe = onMessage(messaging, (payload) => {
        console.log("Foreground message received:", payload);

        // toast(` message from ${payload.data.senderName}: ${payload.notification.body}`, {
        //   position: 'top-right',
        //   autoClose: 5000,
        // });
      });

      return () => unsubscribe();
    }
  }, [userId]);

  return null;
};

export default NotificationHandler;
